import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { buildName, deepEqual } from "helper/tools";
import RevisarResetPasswordModal from "./RevisarResetPasswordModal";
import toast from "react-hot-toast";
import * as api from "helper/helper";
import { scheduleHoursFormValidate } from "../../../../helper/validate";
import { useFormik } from "formik";
import SkeletonTable from "../Skeleton/SkeletonTable";
//import isEqual from "lodash.isequal"; // Requires installing lodash.isequal

const BonificacionesTable = forwardRef(
  ({ items, tryApprove, openItem, reload, isLoading = false }, ref) => {
    const creditLevelActionsModalRef = useRef();

    const [item, setItem] = useState({});

    useImperativeHandle(ref, () => ({
      submit: (desc) => {
        formik.handleSubmit();
      },
    }));

    const formik = useFormik({
      initialValues: items,
      enableReinitialize: true,
      validate: () => scheduleHoursFormValidate,
      validateOnBlur: false,
      validateOnChange: false,
      onSubmit: async (values) => {
        //const { initialValues, values } = useFormikContext();

        const diferences = [];
        const newItems = [];

        formik.values.forEach((element) => {
          const foundItem = items.find((item, index) => item.id === element.id);
          if (foundItem == null) {
            newItems.push(element);
            return false;
          }

          const difs = deepEqual(foundItem, element);
          if (!difs) {
            const copyElement = { ...element };
            diferences.push(copyElement);

            /*  const copyElement = { ...element };
            delete copyElement.promocionDetalles;
            diferences.push(copyElement);*/
          }
        });

        if (diferences.length === 0) {
          return;
        }

        /*    if (isEqual(formik.initialValues, formik.values)) {
  console.log("No changes detected, skipping API call.");
  return;*/
        // Logic to send changed data goes here

        const payload = diferences.map((value, index) => {
          return {
            id: value.id,
            ver: value.ver,
            editar: value.editar,
            exclusivoAsociado: value.promocionDetalles[0].exclusivoAsociado,
            descuento: value.promocionDetalles[0].descuento,
            minimoDescuento: value.promocionDetalles[0].minimoDescuento,
            maximoDescuento: value.promocionDetalles[0].maximoDescuento,
          };
        });

        let responseUpdate = await api
          .updatePromocionesConfigurar(payload)
          .catch((e) => {
            console.log(e);
            toast.error("Error al actualizar promociones");
          });
        if (responseUpdate) {
          toast.success("Promociones actualizados actualizado");
          //  setPendings(responseUpdate);
          reload();
        }
      },
    });

    function handleSubmit(event) {
      event.preventDefault();
    }

    return (
      <>
        <RevisarResetPasswordModal
          ref={creditLevelActionsModalRef}
          item={item}
          reload={reload}
        />
        <form className="row g-3" onSubmit={handleSubmit}>
          <table className="table table-borderless datable">
            <thead className="table-light" style={{ textAlign: "left" }}>
              <tr>
                <th scope="col" style={{ textAlign: "left" }}>
                  Nombre
                </th>

                <th scope="col" style={{ textAlign: "center" }}>
                  Ver
                </th>

                <th scope="col" style={{ textAlign: "center" }}>
                  Editar
                </th>
                <th scope="col" style={{ textAlign: "center" }}>
                  Bonificaciones porcentaje
                </th>
              </tr>
            </thead>
            <tbody style={{ textAlign: "center" }}>
              {isLoading && <SkeletonTable columnCount={4} rowCount={6} />}

              {!isLoading &&
                formik.values &&
                formik.values.length > 0 &&
                formik.values.map((item, index) => {
                  const nombre = buildName(item, true);

                  const ver = item.ver;
                  const editar = item.editar;
                  let descuentoDefault = 0;
                  let maximoDescuento = 50,
                    minimoDescuento = 10;

                  if (item.promocionDetalles.length > 0) {
                    const detalles = item.promocionDetalles[0];

                    descuentoDefault = detalles.descuento.toString();

                    maximoDescuento = detalles.maximoDescuento.toString();
                    minimoDescuento = detalles.minimoDescuento.toString();
                  }

                  const onlyRead = item.id === 4; // es promocion regalo no se deja cambiar
                  if (onlyRead) {
                    maximoDescuento = 100;
                    minimoDescuento = 100;
                  }

                  /*      const date = format(
                item.resetPasswordSolicitado,
                "dd/MM/yy hh:mm a"
              );*/

                  //  const date = "";

                  const minMaxDescuento = parseInt(minimoDescuento) + 1;
                  /*  if (parseInt(minimoDescuento) >= parseInt(maximoDescuento)) {
                    maximoDescuento = minimoDescuento;
                  }*/

                  return (
                    <tr key={item.id} style={{ verticalAlign: "middle" }}>
                      <td style={{ textAlign: "left" }}>{nombre}</td>
                      <th scope="row">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                          checked={ver}
                          onChange={(event) => {
                            //item.ver = e.target.value;

                            let newItems = JSON.parse(
                              JSON.stringify([...formik.values]),
                            );
                            newItems[index].ver = event.target.checked;

                            formik.setValues(newItems);

                            //  formik.handleSubmit();
                          }}
                        />
                      </th>
                      <td>
                        <div
                          className="form-check form-switch"
                          style={{ paddingLeft: "0px" }}
                        >
                          <input
                            className="form-check-input"
                            style={{
                              marginLeft: "0px",
                              paddingLeft: "0px",
                              paddingRigth: "0px",
                            }}
                            type="checkbox"
                            id="flexSwitchCheckChecked"
                            checked={editar}
                            disabled={onlyRead}
                            onChange={(event) => {
                              //item.ver = e.target.value;

                              let newItems = JSON.parse(
                                JSON.stringify([...formik.values]),
                              );
                              newItems[index].editar = event.target.checked;

                              formik.setValues(newItems);

                              //  formik.handleSubmit();
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexSwitchCheckChecked"
                          ></label>
                        </div>
                      </td>

                      <td>
                        <div className="row">
                          <div className="col">
                            <div className="input-group mb-3">
                              <div className="form-floating">
                                <input
                                  type="number"
                                  className="form-control"
                                  id="floatingInputGroup1"
                                  placeholder="Username"
                                  min={minimoDescuento}
                                  max={maximoDescuento}
                                  step="1"
                                  value={descuentoDefault}
                                  disabled={onlyRead}
                                  onBlur={(event) => {
                                    let newItems = JSON.parse(
                                      JSON.stringify([...formik.values]),
                                    );
                                    if (
                                      newItems[index].promocionDetalles.length >
                                      0
                                    ) {
                                      let detalle =
                                        newItems[index].promocionDetalles[0];

                                      if (
                                        event.target.value > maximoDescuento
                                      ) {
                                        detalle.descuento = maximoDescuento;
                                      }
                                      if (
                                        event.target.value < minimoDescuento
                                      ) {
                                        detalle.descuento = minimoDescuento;
                                      }

                                      formik.setValues(newItems);
                                    }
                                  }}
                                  onChange={(event) => {
                                    //item.ver = e.target.value;
                                    let value = parseInt(
                                      event.currentTarget.value,
                                    );

                                    let newItems = JSON.parse(
                                      JSON.stringify([...formik.values]),
                                    );

                                    let newMaxValue = value;
                                    if (isNaN(value)) {
                                      newMaxValue =
                                        newItems[index].promocionDetalles[0]
                                          .minimoDescuento;
                                    } else if (newMaxValue >= 50) {
                                      newMaxValue = 50;
                                    } else if (newMaxValue < 10) {
                                      newMaxValue = 10;
                                    }

                                    newItems[
                                      index
                                    ].promocionDetalles[0].descuento =
                                      newMaxValue;

                                    if (newMaxValue >= maximoDescuento) {
                                      newItems[
                                        index
                                      ].promocionDetalles[0].maximoDescuento =
                                        newMaxValue;
                                    }

                                    if (minimoDescuento > newMaxValue) {
                                      newItems[
                                        index
                                      ].promocionDetalles[0].minimoDescuento =
                                        newMaxValue;
                                    }
                                    ///

                                    formik.setValues(newItems);
                                  }}
                                />
                                <label htmlFor="floatingInputGroup1">
                                  Default
                                </label>
                              </div>
                              <span className="input-group-text">%</span>
                            </div>
                          </div>
                          <div className="col">
                            <div className="input-group mb-3">
                              <div className="form-floating">
                                <input
                                  type="number"
                                  className="form-control"
                                  id="floatingInputGroup1"
                                  placeholder="Username"
                                  min="10"
                                  step="1"
                                  value={minimoDescuento}
                                  max={49}
                                  onInput={(e) => {
                                    let value = parseInt(e.currentTarget.value);

                                    let newItems = JSON.parse(
                                      JSON.stringify([...formik.values]),
                                    );
                                    ///
                                    let newMaxValue = value;
                                    if (isNaN(value)) {
                                      newMaxValue =
                                        newItems[index].promocionDetalles[0]
                                          .minimoDescuento;
                                    } else if (newMaxValue >= 50) {
                                      newMaxValue = 50 - 1;
                                    } else if (newMaxValue < 10) {
                                      newMaxValue = 10;
                                      //  belowMinimumDescuento = true;
                                    }

                                    newItems[
                                      index
                                    ].promocionDetalles[0].minimoDescuento =
                                      newMaxValue;
                                    ///

                                    if (newMaxValue >= maximoDescuento) {
                                      newItems[
                                        index
                                      ].promocionDetalles[0].maximoDescuento =
                                        newMaxValue + 1;
                                    }

                                    if (descuentoDefault < newMaxValue) {
                                      newItems[
                                        index
                                      ].promocionDetalles[0].descuento =
                                        newMaxValue;
                                    }

                                    formik.setValues(newItems);

                                    //  setValuePercent(value);
                                  }}
                                  disabled={onlyRead}
                                />
                                <label htmlFor="floatingInputGroup1">
                                  Minimo
                                </label>
                              </div>
                              <span className="input-group-text">%</span>
                            </div>
                          </div>
                          <div className="col">
                            <div className="input-group mb-3">
                              <div className="form-floating">
                                <input
                                  type="number"
                                  className="form-control"
                                  id="floatingInputGroup1"
                                  placeholder="Username"
                                  step="1"
                                  value={maximoDescuento}
                                  min={11}
                                  max={50}
                                  onInput={(e) => {
                                    let value = parseInt(e.currentTarget.value);

                                    let newItems = JSON.parse(
                                      JSON.stringify([...formik.values]),
                                    );

                                    //  let belowMinimumDescuento = false;
                                    let newMaxValue = value;
                                    if (isNaN(value)) {
                                      newMaxValue =
                                        newItems[index].promocionDetalles[0]
                                          .maximoDescuento;
                                    } else if (newMaxValue >= 50) {
                                      newMaxValue = 50;
                                    } else if (newMaxValue < 10) {
                                      newMaxValue = 10 + 1;
                                      //  belowMinimumDescuento = true;
                                    }

                                    newItems[
                                      index
                                    ].promocionDetalles[0].maximoDescuento =
                                      newMaxValue;

                                    if (
                                      newMaxValue <= parseInt(minimoDescuento)
                                    ) {
                                      let newMinimoDescuento = newMaxValue - 1;

                                      newItems[
                                        index
                                      ].promocionDetalles[0].minimoDescuento =
                                        newMinimoDescuento;

                                      //formik.setValues(newItems);
                                    }

                                    if (descuentoDefault > newMaxValue) {
                                      let detalle =
                                        newItems[index].promocionDetalles[0];
                                      detalle.descuento = newMaxValue;
                                    }

                                    //
                                    formik.setValues(newItems);

                                    //  formik.setValues(newItems);
                                  }}
                                  disabled={onlyRead}
                                />
                                <label htmlFor="floatingInputGroup1">
                                  Maximo
                                </label>
                              </div>
                              <span className="input-group-text">%</span>
                            </div>
                          </div>
                        </div>
                      </td>

                      {/*<td>
                    <button
                      type="button"
                      className={`btn btn-sm btn-warning`}
                      onClick={(e) => tryApprove1(item)}
                    >
                      Revisar
                    </button>
                  </td>*/}
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </form>
      </>
    );
  },
);

export default BonificacionesTable;
